import Axios from "axios";
import { TSettingsState } from "../store/settings/settingsReducer";

export const axiosSaveUserSettings = (settings: TSettingsState) => {
  Axios.put("/user/update-settings/", settings);
};
